/// <amd-module name="Search/Shared/Components/TimeoutComponent" />
export * from "./TimeoutComponent/index";
